/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoLoginTwoFaAuthRequest model module.
 * @module model/ManagerAccountControllerDtoLoginTwoFaAuthRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoLoginTwoFaAuthRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoLoginTwoFaAuthRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoLoginTwoFaAuthRequest
     * @param twofaAuthCode {String} 
     * @param twofaNo {String} 
     */
    constructor(twofaAuthCode, twofaNo) { 
        
        ManagerAccountControllerDtoLoginTwoFaAuthRequest.initialize(this, twofaAuthCode, twofaNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, twofaAuthCode, twofaNo) { 
        obj['twofaAuthCode'] = twofaAuthCode;
        obj['twofaNo'] = twofaNo;
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoLoginTwoFaAuthRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoLoginTwoFaAuthRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoLoginTwoFaAuthRequest} The populated <code>ManagerAccountControllerDtoLoginTwoFaAuthRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoLoginTwoFaAuthRequest();

            if (data.hasOwnProperty('twofaAuthCode')) {
                obj['twofaAuthCode'] = ApiClient.convertToType(data['twofaAuthCode'], 'String');
            }
            if (data.hasOwnProperty('twofaNo')) {
                obj['twofaNo'] = ApiClient.convertToType(data['twofaNo'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoLoginTwoFaAuthRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoLoginTwoFaAuthRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerAccountControllerDtoLoginTwoFaAuthRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['twofaAuthCode'] && !(typeof data['twofaAuthCode'] === 'string' || data['twofaAuthCode'] instanceof String)) {
            throw new Error("Expected the field `twofaAuthCode` to be a primitive type in the JSON string but got " + data['twofaAuthCode']);
        }
        // ensure the json data is a string
        if (data['twofaNo'] && !(typeof data['twofaNo'] === 'string' || data['twofaNo'] instanceof String)) {
            throw new Error("Expected the field `twofaNo` to be a primitive type in the JSON string but got " + data['twofaNo']);
        }

        return true;
    }


}

ManagerAccountControllerDtoLoginTwoFaAuthRequest.RequiredProperties = ["twofaAuthCode", "twofaNo"];

/**
 * @member {String} twofaAuthCode
 */
ManagerAccountControllerDtoLoginTwoFaAuthRequest.prototype['twofaAuthCode'] = undefined;

/**
 * @member {String} twofaNo
 */
ManagerAccountControllerDtoLoginTwoFaAuthRequest.prototype['twofaNo'] = undefined;






export default ManagerAccountControllerDtoLoginTwoFaAuthRequest;

